import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { FormUtils } from 'app/tools/form-utils';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-placa',
  templateUrl: './text-placa.component.html',
  styleUrls: ['./text-placa.component.scss'],
  viewProviders: [ParentFormGroup],
})
export class TextPlacaComponent implements OnInit {

  @Input() readonly:boolean;
  public mask = FormUtils.PLACA_MASK;
  formGroup: FormGroup;
  
  constructor(private _controlContainer: ControlContainer) {}

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.dasabilitarLgVeiculoNovo();
  }
  
  fixPlaca(nrPlaca) {
    return (nrPlaca.value = nrPlaca.value.replace(/[^0-9a-z]/gi, '').toUpperCase());
  } 

  verificarPlacaMercosul(nrPlaca: string): boolean {
    return /^[a-zA-Z]{3}\d[a-zA-Z]\d{2}$/.test(nrPlaca);
  }

  dasabilitarLgVeiculoNovo(){
    this.formGroup.get('nrPlaca').valueChanges.subscribe(nrPlaca =>{
      nrPlaca ? this.formGroup.get('lgVeiculoNovo').disable() : this.formGroup.get('lgVeiculoNovo').enable();
    })
  }
}
